import formatsIndex from './index'
import keirekishoFormatsIndex from './keirekisho_index'
import rirekishoFormatsIndex from './rirekisho_index'
export default (id) => {
  let formatDetail = formatsIndex.find(function (format) {
    return format.id === id
  })
  if (!formatDetail) {
    return keirekishoFormatsIndex.find(function (format) {
      return format.id === id
    })
  } else {
      if (!formatDetail) {
        return rirekishoFormatsIndex.find(function (format) {
          return format.id === id
        })
      } else {
        return formatDetail
      }
  }

}
